import builder from "@faire/web-api/routes/builder";
import { RenderWithBuilder } from "@faire/web/builder/BuilderComponents/RenderWithBuilder";
import { THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES } from "@faire/web/common/consts/THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES";
import React from "react";
import { matchPath, useLocation } from "react-router-dom";

import { Footer } from "@faire/retailer/components/Footer";
import { useIsLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { getSessionCountry } from "@faire/retailer/serialized-data/getSessionCountry";
import { BUILDER_LANDING_PAGE_MODEL_NAME } from "@faire/retailer/views/builder/const";

export const BuilderMarketingLandingPage: React.FC = () => {
  const { pathname } = useLocation();
  const isOnTestingLandingPage = matchPath(pathname, builder());

  const isLoggedInRetailer = useIsLoggedInRetailer();
  const userCountry = getSessionCountry();
  const isEurope = THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES.includes(
    userCountry as (typeof THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES)[number]
  );

  // "/builder" is only for testing
  // other routes are actual builder marketing landing pages
  if (isOnTestingLandingPage) {
    return (
      <>
        <RenderWithBuilder modelName="brand-financing" />
        <RenderWithBuilder modelName="templates" />
      </>
    );
  } else {
    return (
      <>
        <RenderWithBuilder
          modelName={BUILDER_LANDING_PAGE_MODEL_NAME}
          // isEurope is used for affiliates
          // isLoggedInRetailer is not currently used, but it's here for future use
          targets={{ isLoggedInRetailer, isEurope }}
        />
        <Footer />
      </>
    );
  }
};
